import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';


const initialState = {
    userid: null,
    firstName: "",
    lastName: "",
    birthday: "",
    email: "",
    password: "",
    confirmPassword: "",
    language: "de",
    guicolor: "hell",
    standardview: "grid",
    //time: "WET West-European-Time",
    file: null,
    vim_accesscode: "",
    notifications: {
        filesUpdate: false,
        filesRelease: false,
        filesDistribution: false,
        projectsUpdate: false,
        projectsRelease: false,
        projectsDelete: false,
        projectsProcess: false,
        actionsUpdate: false,
        actionsRelease: false,
        actionsProcess: false,
    }
}


const profileSaveUser = (state = initialState, action) => {
    return action.profiles

}

const profileSaveUserFail = (state, action) => {

    return updateObject(state, {
        error: action.error
    });
}

const profileSaveUserSuccess = (state, action) => {
    return action.profile
}

const profileEitUserFail = (state, action) => {

    return updateObject(state, {
        error: action.error
    });
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PROFILE_SAVE_USER: return profileSaveUser(state, action);
        case actionTypes.PROFILE_SAVE_USER_FAIL: return profileSaveUserFail(state, action);
        case actionTypes.PROFILE_SAVE_USER_SUCCESS: return profileSaveUserSuccess(state, action);
        case actionTypes.PROFILE_EDIT_USER_FAIL: return profileEitUserFail(state, action);
        case actionTypes.PROFILE_RESET_ERROR: 
            return updateObject(state, { error: null });
        default:
            return state;
    }
}

export default reducer;
